module.exports = __webpack_public_path__ + "static/media/supportwhite-icon.a58751b3.svg";